export const Texts = {
  WELCOME: 'ברוך הבא',
  PROTEXTION_CERTIFICATES: 'הפקת אישורי מיגון',
  ENRER_DETAILS: 'להפקת האישור נא הכניסו את הפרטים הנדרשים ופעלו לפי ההוראות',
  IS_PRIVATE_VEHICLE: 'האם הרכב בבעלות פרטית או עסקית?',
  PRIVATE_CUSTOMER: 'בעלות פרטית',
  BUSINESS_CUSTOMER: 'בעלות עסקית',
  ENTER_ID: 'יש להקיש מס׳ ת.ז. כולל ספרת ביקורת',
  ENTER_COMPANY_ID: 'יש להקיש מס׳ ח.פ.',
  ENTER_COMPANY_PHONE: 'יש להקיש מס׳ נייד של דורש המיגון',
  ENTER_CAR_NUMBER: 'יש להקיש מס׳ רכב',
  SELECT_COMMUNICATION_CHANNEL: 'נא בחרו את ערוץ התקשורת אליו ישלח אישור המיגון',
  EMAIL: 'אימייל',
  PHONE_NUMBER: 'מספר נייד',
  ENTER_EMAIL: 'יש להקיש כתובת דוא״ל',
  ENTER_PHONE_NUMBER: 'יש להקיש מספר נייד',
  GET_PASSWORD: 'לקבלת סיסמה',
  INVALID_PHONE: 'מספר טלפון לא חוקי',
  INVALID_EMAIL: 'אימייל לא חוקי',
  INVALID_ID: 'מספר זהות לא חוקי',
  INVALID_COMPANY_ID: 'מספר ח.פ. לא חוקי',
  INVALID_CAR_NUMBER: 'מספר רכב לא חוקי',
  ENTER_PASSWORD: 'הזנת סיסמה',
  MESSAGE_SENT_AT_THIS_MOMENT: 'ברגעים אלו נשלחה הודעה לערוץ התקשורת שבחרתם',
  TYPE_THE_CODE: 'נא הקלידו את הקוד המופיע בהודעה',
  SEND: 'שלח',
  CODE_VALIDITY: 'הקוד יהיה בתוקף למשך 10 דק׳ בלבד',
  CLICK_APPROVAL: 'נא לחצו אישור',
  TO_CREATE_APPROVAL: 'להפקת אישור מיגון לרכב מספר',
  CREATE_APPROVAL: 'הפקת אישור',
  APPROVAL: 'אישור',
  PROTEXTION_CERTIFICATES_ENDED: 'הפקת האישור הסתיימה בהצלחה',
  EXPIRIATION_CERTIFICATION:
    'ברגעים אלו נשלח אליכם קישור להורדת אישור המיגון שימו לב האישור יהיה זמין להדפסה למשך 72 שעות בלבד. לאחר מכן יהיה צורך לבצע את פעולת ההפקה מחדש.',
  THANK: 'תודה',
  OPS: 'אופס!',
  EXPIRED: 'תוקף האישור פג.',
  RESTART: 'נא התחילו את תהליך ההזדהות מחדש',
  START_AGAIN: 'להתחיל שוב',
  ADDITIONAL_APPROVAL: 'אישור נוסף',
};
